import { render, staticRenderFns } from "./OpenIDTest.vue?vue&type=template&id=59c594d8&"
import script from "./OpenIDTest.vue?vue&type=script&lang=js&"
export * from "./OpenIDTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports